import { Sparkles, TrendingUp, Wrench } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { fmtDate } from "@/components/hub/Common";

const ICONS = { new: [Sparkles, "#3ad7ff"], improved: [TrendingUp, "#a746ff"], fix: [Wrench, "#ffc94d"] };

export const ReleaseItems = ({ items, testid }) => {
  const { t } = useI18n();
  return (
    <ul className="space-y-2.5" data-testid={testid}>
      {items.map((it, i) => {
        const [Icon, c] = ICONS[it.type] || ICONS.new;
        return (
          <li key={i} className="flex gap-3 items-start cx-rise" style={{ animationDelay: `${i * 0.04}s` }}>
            <span className="mt-0.5 w-7 h-7 shrink-0 rounded-md grid place-items-center border" style={{ color: c, borderColor: `${c}55`, background: `${c}14` }} title={t(`rel.type_${it.type}`)}>
              <Icon className="w-3.5 h-3.5" />
            </span>
            <span className="text-sm text-slate-300 leading-relaxed"><b className="font-mono text-[10px] uppercase tracking-wider mr-2" style={{ color: c }}>{t(`rel.type_${it.type}`)}</b>{it.text}</span>
          </li>
        );
      })}
    </ul>
  );
};

export const ReleaseCard = ({ r, latest }) => {
  const { t } = useI18n();
  return (
    <article data-testid={`release-${r.version}`} className={`relative cx-card rounded-2xl p-6 sm:p-8 ${latest ? "border-[#2f7bff]/50 shadow-[0_0_60px_-20px_rgba(47,123,255,0.8)]" : ""}`}>
      <div className="flex flex-wrap items-center gap-3">
        <span className="font-display font-bold text-2xl sm:text-3xl cx-text-grad" data-testid={`release-version-${r.version}`}>V{r.version}</span>
        {latest && <span className="rounded-full px-2.5 py-1 text-[10px] font-mono uppercase tracking-widest bg-[#2f7bff]/20 text-[#3ad7ff] border border-[#2f7bff]/40">{t("rel.latest")}</span>}
        <span className="text-xs text-slate-500 font-mono ml-auto">{fmtDate(r.published_at)}</span>
      </div>
      <h3 className="font-display text-xl text-white mt-3">{r.title}</h3>
      {r.summary && <p className="text-sm text-slate-400 mt-2 mb-5">{r.summary}</p>}
      <ReleaseItems items={r.items} testid={`release-items-${r.version}`} />
    </article>
  );
};
